/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import Select from "react-select";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import Flatpickr from "react-flatpickr";
import { Row, Col, Button, Input, Card, CardBody, Badge, Label } from "reactstrap";
import { LocalizationProvider, DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { reloadWindowToPath } from "../../Helpers/Utils";
import DeleteModal from "../Common/DeleteModal";

dayjs.extend(isBetween);

const FLATPICKR_CONFIG = {
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    closeOnSelect: false,
    time_24hr: true
};

const formatForDateTimeInput = (val) => {
    if (!val) return "";
    return dayjs(val).format("YYYY-MM-DDTHH:mm");
};

const CreateManualInvoice = () => {
    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);
    const [customers, setCustomers] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const [form, setForm] = useState({
        customer_id: null,
        vessel_name: "",
        gst_percent: 9,
        description: "", 
        invoice_number: "", // Added manual invoice number
    });

    const [items, setItems] = useState([{
        vehicle_id: null,
        driver_id: null,
        job_date: dayjs(),
        work_start_datetime: null,
        work_end_datetime: null,
        pickup_location: "",
        delivery_location: "",
        pallet_per_lorry: "",
        quantity: 1,
        rates: null,
        is_holiday: false,
        extra_charges: 0, 
        extra_charges_description: "", 
        normal_hrs: 0, normal_hrs_ot: 0,
        after_office_hrs: 0, offz_hrs_ot: 0,
        holiday: 0, holiday_ot: 0,
        line_total: 0,
        rate_applied: 0
    }]);

    useEffect(() => {
        const loadData = async () => {
            const [cusRes, vehRes, driRes] = await Promise.all([
                Handler({ method: "get", url: "/customer/list.php?status=active&limit=1000" }),
                Handler({ method: "get", url: "/vehicle/list.php" }),
                Handler({ method: "get", url: "/driver/list.php" })
            ]);
            if (cusRes?.success) setCustomers(cusRes.data.map(c => ({ value: c.id, label: `${c.company_name}${c.customer_code ? ` (${c.customer_code})` : ''}` })));
            if (vehRes?.success) setVehicles(vehRes.data.map(v => ({ value: v.id, lorry_name: v.lorry_type, label: `${v.vehicle_number} (${v.lorry_type})` })));
            if (driRes?.success) setDrivers(driRes.data.map(d => ({ value: d.id, label: d.name })));
        };
        loadData();
    }, []);

    // ⭐ AUTO CALCULATION LOGIC (OLD - COMMENTED) ⭐
    // const autoCalculate = (item) => {
    //     if (!item.work_start_datetime || !item.work_end_datetime || !item.rates) return item;

    //     const start = dayjs(item.work_start_datetime);
    //     const end = dayjs(item.work_end_datetime);
    //     const totalDurationHrs = end.diff(start, 'hour', true);

    //     if (totalDurationHrs <= 0) return item;

    //     const dayOfWeek = start.day(); 
    //     const startTimeStr = start.format("HH:mm");

    //     let normal_hrs = 0, normal_hrs_ot = 0;
    //     let after_office_hrs = 0, offz_hrs_ot = 0;
    //     let holiday = 0, holiday_ot = 0;
    //     let appliedRate = 0;

    //     const r = item.rates;

    //     if (item.is_holiday || dayOfWeek === 0) {
    //         holiday = Math.min(totalDurationHrs, 3);
    //         holiday_ot = Math.max(0, totalDurationHrs - 3);
    //         appliedRate = Number(r.holiday || 0);
    //     } else {
    //         let isNormalWindow = false;
    //         if (dayOfWeek >= 1 && dayOfWeek <= 5) {
    //             if (startTimeStr >= "08:00" && startTimeStr <= "16:59") isNormalWindow = true;
    //         } else if (dayOfWeek === 6) {
    //             if (startTimeStr >= "08:00" && startTimeStr <= "11:59") isNormalWindow = true;
    //         }

    //         const basicHrs = Math.min(totalDurationHrs, 3);
    //         const otHrs = Math.max(0, totalDurationHrs - 3);

    //         if (isNormalWindow) {
    //             normal_hrs = basicHrs;
    //             normal_hrs_ot = otHrs;
    //             appliedRate = Number(r.normal_hrs || 0);
    //         } else {
    //             after_office_hrs = basicHrs;
    //             offz_hrs_ot = otHrs;
    //             appliedRate = Number(r.after_office_hrs || 0);
    //         }
    //     }

    //     const line_total =
    //         (normal_hrs * Number(r.normal_hrs || 0)) +
    //         (normal_hrs_ot * Number(r.normal_hrs_ot || 0)) +
    //         (after_office_hrs * Number(r.after_office_hrs || 0)) +
    //         (offz_hrs_ot * Number(r.offz_hrs_ot || 0)) +
    //         (Number(r.holiday || 0)) +
    //         (holiday_ot * Number(r.holiday_ot || 0)) +
    //         Number(item.extra_charges || 0); 

    //     return {
    //         ...item,
    //         normal_hrs: normal_hrs.toFixed(2),
    //         normal_hrs_ot: normal_hrs_ot.toFixed(2),
    //         after_office_hrs: after_office_hrs.toFixed(2),
    //         offz_hrs_ot: offz_hrs_ot.toFixed(2),
    //         holiday: holiday.toFixed(2),
    //         holiday_ot: holiday_ot.toFixed(2),
    //         line_total: line_total.toFixed(2),
    //         rate_applied: appliedRate
    //     };
    // };

    // ⭐ Updated autoCalculate Logic ⭐
    const autoCalculate = (item) => {
        if (!item.work_start_datetime || !item.work_end_datetime || !item.rates) return item;
        const start = dayjs(item.work_start_datetime);
        const end = dayjs(item.work_end_datetime);
        const totalDurationHrs = end?.diff(start, 'hour', true);
        if (totalDurationHrs <= 0) return item;
        const r = item.rates;
        let normal_hrs = 0, normal_hrs_ot = 0;
        let after_office_hrs = 0, offz_hrs_ot = 0;
        let holiday = 0, holiday_ot = 0;
        let basic_fixed_cost = 0;

        const dayOfWeek = start.day();
        const startTimeStr = start.format("HH:mm");

        if (item.is_holiday || dayOfWeek === 0) {
            holiday = Math.min(totalDurationHrs, 3);
            basic_fixed_cost = Number(r.holiday || 0);
        } else {
            let isNormalStart = false;
            if (dayOfWeek >= 1 && dayOfWeek <= 5) {
                if (startTimeStr >= "08:00" && startTimeStr <= "16:59") isNormalStart = true;
            } else if (dayOfWeek === 6) {
                if (startTimeStr >= "08:00" && startTimeStr <= "11:59") isNormalStart = true;
            }

            if (isNormalStart) {
                normal_hrs = Math.min(totalDurationHrs, 3);
                basic_fixed_cost = Number(r.normal_hrs || 0);
            } else {
                after_office_hrs = Math.min(totalDurationHrs, 3);
                basic_fixed_cost = Number(r.after_office_hrs || 0);
            }
        }

        if (totalDurationHrs > 3) {
            let otStartTime = start.add(3, 'hour');
            const otTotalHrs = totalDurationHrs - 3;

            for (let i = 0; i < otTotalHrs; i += 0.5) {
                let currentStep = otStartTime.add(i, 'hour');
                let stepDay = currentStep.day();
                let stepTimeStr = currentStep.format("HH:mm");
                let increment = Math.min(0.5, otTotalHrs - i);

                if (item.is_holiday || stepDay === 0) {
                    holiday_ot += increment;
                } else {
                    let isNormalWindow = false;
                    if (stepDay >= 1 && stepDay <= 5) {
                        if (stepTimeStr >= "08:00" && stepTimeStr <= "16:59") isNormalWindow = true;
                    } else if (stepDay === 6) {
                        if (stepTimeStr >= "08:00" && stepTimeStr <= "11:59") isNormalWindow = true;
                    }

                    if (isNormalWindow) {
                        normal_hrs_ot += increment;
                    } else {
                        offz_hrs_ot += increment;
                    }
                }
            }
        }

        const line_total =
            basic_fixed_cost +
            (normal_hrs_ot * Number(r.normal_hrs_ot || 0)) +
            (offz_hrs_ot * Number(r.offz_hrs_ot || 0)) +
            (holiday_ot * Number(r.holiday_ot || 0)) +
            Number(item.extra_charges || 0);

        return {
            ...item,
            normal_hrs: normal_hrs.toFixed(2),
            normal_hrs_ot: normal_hrs_ot.toFixed(2),
            after_office_hrs: after_office_hrs.toFixed(2),
            offz_hrs_ot: offz_hrs_ot.toFixed(2),
            holiday: holiday.toFixed(2),
            holiday_ot: holiday_ot.toFixed(2),
            line_total: line_total.toFixed(2),
            rate_applied: basic_fixed_cost 
        };
    };

    const removeItem = (index) => {
        if (items.length > 1) {
            const updated = items.filter((_, idx) => idx !== index);
            setItems(updated);
        }
    };

    const handleCustomerChange = async (selectedCustomer) => {
        const customerId = selectedCustomer ? selectedCustomer.value : null;
        setForm(prev => ({ ...prev, customer_id: customerId }));

        if (!customerId) {
            // Clear rates if no customer is selected
            const resetItems = items.map(item => ({ ...item, rates: null, line_total: "0.00" }));
            setItems(resetItems);
            return;
        }

        // Fetch rates for this customer
        const res = await Handler({ method: "get", url: `/quotation/get_rate.php?customer_id=${customerId}` });
        if (res?.success) {
            const updatedItems = items.map(item => {
                if (item.vehicle_id) {
                    const vehicleRate = res.data.find(v => String(v.vehicle_id) === String(item.vehicle_id.value))
                        || res.data.find(v => String(v.lorry_type).toLowerCase() === String(item.lorry_type).toLowerCase());
                    const updated = { ...item, rates: vehicleRate };
                    return autoCalculate(updated);
                }
                return item;
            });
            setItems(updatedItems);
        }
    };

    const handleItemChange = async (index, field, value) => {
        let updatedItems = items.map((it, idx) => {
            if (idx !== index) return it;

            let formattedVal = value;
            if ((field === "work_start_datetime" || field === "work_end_datetime") && value) {
                formattedVal = dayjs(value).format("YYYY-MM-DD HH:mm");
            }

            let newItem = { ...it, [field]: formattedVal };

            if (field === "work_start_datetime" && formattedVal) {
                newItem.job_date = dayjs(formattedVal);
            }

            return autoCalculate(newItem);
        });

        if (field === "vehicle_id" && form.customer_id) {
            const res = await Handler({ method: "get", url: `/quotation/get_rate.php?customer_id=${form.customer_id}` });
            if (res?.success) {
                const vehicleData = vehicles.find(v => v.value === value.value);
                const vehicleRate = res.data.find(v => String(v.vehicle_id) === String(value.value))
                    || res.data.find(v => String(v.lorry_type).toLowerCase() === String(vehicleData?.lorry_name).toLowerCase());
                updatedItems[index].rates = vehicleRate;
                updatedItems[index].lorry_type = vehicleData?.lorry_name;
                updatedItems[index] = autoCalculate(updatedItems[index]);
            }
        }

        setItems(updatedItems);
    };

    const subtotal = items.reduce((acc, it) => acc + Number(it.line_total), 0);
    const gstAmount = (subtotal * Number(form.gst_percent)) / 100;
    const grandTotal = subtotal + gstAmount;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.customer_id) return toast.error("Select Customer");

        dispatch(loadingTrue());
        const payload = {
            customer_id: form.customer_id,
            vessel_name: form.vessel_name,
            gst_percent: form.gst_percent,
            description: form.description,
            invoice_number: form.invoice_number, // Pass manual invoice number
            items: items?.map(it => ({
                vehicle_id: it.vehicle_id?.value, 
                lorry_type: it.lorry_type,
                driver_id: it.driver_id?.value,
                quantity: it.quantity,
                pallet_per_lorry: it.pallet_per_lorry,
                pickup_location: it.pickup_location,
                delivery_location: it.delivery_location,
                job_date: dayjs(it.job_date).format("YYYY-MM-DD"),
                rate: it.rate_applied,
                normal_hrs: it.normal_hrs,
                normal_hrs_ot: it.normal_hrs_ot,
                after_office_hrs: it.after_office_hrs,
                offz_hrs_ot: it.offz_hrs_ot,
                holiday: it.holiday,
                holiday_ot: it.holiday_ot,
                extra_charges: it.extra_charges,
                extra_charges_description: it.extra_charges_description,
                line_total: it.line_total,
                work_start_datetime: it.work_start_datetime ? dayjs(it.work_start_datetime).format("YYYY-MM-DD HH:mm:ss") : null,
                work_end_datetime: it.work_end_datetime ? dayjs(it.work_end_datetime).format("YYYY-MM-DD HH:mm:ss") : null,
                vessel_name: it.vessel_name || "",
                description: it.description || "",
            }))
        };

        const res = await Handler({ method: "post", url: "/invoice/create.php", data: payload });
        if (res?.success) {
            toast.success("Invoice Created Successfully!");
        } else {
            toast.error(res?.message || "Failed to create invoice");
        }
        dispatch(loadingFalse());
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="page-card p-4 bg-white rounded-4 shadow-sm">
                <h4 className="fw-bold mb-4 border-bottom pb-2 text-primary">Manual Invoice Execution</h4>
                <form onSubmit={handleSubmit}>
                    <Row className="mb-4 g-3">
                        <Col md={3}>
                            <label className="small fw-bold">Select Customer</label>
                            <Select options={customers} value={customers.find(c => c.value === form.customer_id)} onChange={handleCustomerChange} isClearable />
                        </Col>
                        <Col md={3}>
                            <label className="small fw-bold">Invoice Number</label>
                            <Input type="text" placeholder="Auto Generated" value={form.invoice_number} disabled />
                        </Col>
                        <Col md={2}>
                            <label className="small fw-bold">Vessel Name</label>
                            <Input type="text" placeholder="Vessel Name" value={form.vessel_name} onChange={e => setForm({ ...form, vessel_name: e.target.value })} />
                        </Col>
                        <Col md={2}>
                            <label className="small fw-bold">Description</label>
                            <Input type="text" placeholder="Description" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
                        </Col>
                        <Col md={2}>
                            <label className="small fw-bold">GST (%)</label>
                            <Input type="number" value={form.gst_percent} onChange={e => setForm({ ...form, gst_percent: e.target.value })} />
                        </Col>
                    </Row>

                    {items?.map((item, i) => (
                        <Card key={i} className={`mb-4 border-0 rounded-4 shadow-sm border-start border-5 ${item.is_holiday ? 'border-success' : 'border-primary'} bg-light`}>
                            <CardBody>
                                {items.length > 1 && (
                                    <div className="d-flex justify-content-end mb-2">
                                        <Button color="danger" size="sm" className="rounded-pill px-3" onClick={() => setDeleteIndex(i)}>
                                            <i className="bi bi-trash me-1"></i> Remove Line
                                        </Button>
                                    </div>
                                )}
                                <Row className="g-2 mb-3">
                                    <Col md={3}>
                                        <label className="extra-small fw-bold">Vehicle</label>
                                        <Select options={vehicles} value={vehicles.find(v => v.value === item.vehicle_id?.value)} onChange={v => handleItemChange(i, "vehicle_id", v)} />
                                    </Col>
                                    <Col md={3}>
                                        <label className="extra-small fw-bold">Driver</label>
                                        <Select options={drivers} value={drivers.find(d => d.value === item.driver_id?.value)} onChange={v => handleItemChange(i, "driver_id", v)} />
                                    </Col>
                                    <Col md={2}>
                                        <label className="extra-small fw-bold">Pallet</label>
                                        <Input type="text" placeholder="Pallet Count" value={item.pallet_per_lorry} onChange={e => handleItemChange(i, "pallet_per_lorry", e.target.value)} />
                                    </Col>
                                    <Col md={2}>
                                        <label className="extra-small fw-bold">Pickup</label>
                                        <Input type="text" placeholder="Pickup Location" value={item.pickup_location} onChange={e => handleItemChange(i, "pickup_location", e.target.value)} />
                                    </Col>
                                    <Col md={2}>
                                        <label className="extra-small fw-bold">Delivery</label>
                                        <Input type="text" placeholder="Delivery Location" value={item.delivery_location} onChange={e => handleItemChange(i, "delivery_location", e.target.value)} />
                                    </Col>
                                </Row>

                                <Row className="g-2 align-items-center mb-3">
                                    <Col md={2}>
                                        <label className="extra-small fw-bold">Trip Start</label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                value={item.work_start_datetime ? dayjs(item.work_start_datetime) : null}
                                                onChange={(val) => {
                                                    if (val && val.isValid()) {
                                                        handleItemChange(i, "work_start_datetime", val.format("YYYY-MM-DD HH:mm"));
                                                    } else if (!val) {
                                                        handleItemChange(i, "work_start_datetime", null);
                                                    }
                                                }}
                                                minutesStep={15}
                                                ampm={false}
                                                format="YYYY-MM-DD HH:mm"
                                                slotProps={{
                                                    textField: {
                                                        size: 'small',
                                                        fullWidth: true,
                                                        className: 'bg-white'
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Col>
                                    <Col md={2}>
                                        <label className="extra-small fw-bold">Trip End</label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                value={item.work_end_datetime ? dayjs(item.work_end_datetime) : null}
                                                minDateTime={item.work_start_datetime ? dayjs(item.work_start_datetime) : undefined}
                                                onChange={(val) => {
                                                    if (val && val.isValid()) {
                                                        handleItemChange(i, "work_end_datetime", val.format("YYYY-MM-DD HH:mm"));
                                                    } else if (!val) {
                                                        handleItemChange(i, "work_end_datetime", null);
                                                    }
                                                }}
                                                minutesStep={15}
                                                ampm={false}
                                                format="YYYY-MM-DD HH:mm"
                                                slotProps={{
                                                    textField: {
                                                        size: 'small',
                                                        fullWidth: true,
                                                        className: 'bg-white'
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Col>
                                    <Col md={2}>
                                        <label className="extra-small fw-bold text-muted small">Job Date</label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker value={item.job_date} disabled closeOnSelect={false} slotProps={{ actionBar: { actions: ['cancel', 'accept'] }, textField: { size: 'small', fullWidth: true, disabled: true } }} />
                                        </LocalizationProvider>
                                    </Col>
                                    <Col md={3}>
                                        <label className="extra-small fw-bold">Extra Charges Desc</label>
                                        <Input type="text" placeholder="Description" value={item.extra_charges_description} onChange={e => handleItemChange(i, "extra_charges_description", e.target.value)} />
                                    </Col>
                                    <Col md={1}>
                                        <label className="extra-small fw-bold">Extra Amt</label>
                                        <Input type="number" placeholder="0" value={item.extra_charges} onChange={e => handleItemChange(i, "extra_charges", e.target.value)} />
                                    </Col>
                                    <Col md={2} className="text-end">
                                        <label className="extra-small fw-bold text-success small">Line Total</label>
                                        <div className="h4 fw-bold text-primary mb-0">${item.line_total}</div>
                                    </Col>
                                </Row>

                                <div className="d-flex align-items-center gap-2 pt-2 border-top">
                                    <Input
                                        type="checkbox"
                                        id={`is_holiday_${i}`}
                                        checked={item.is_holiday}
                                        onChange={(e) => handleItemChange(i, "is_holiday", e.target.checked)}
                                        className="m-0"
                                    />
                                    <Label for={`is_holiday_${i}`} className="m-0 small fw-bold text-danger cursor-pointer">
                                        Is this a public holiday trip?
                                    </Label>
                                </div>

                                <Row className="g-2 mt-2 pt-2 border-top">
                                    <Col md={6}>
                                        <label className="extra-small fw-bold text-muted">Trip Vessel Name</label>
                                        <Input type="text" placeholder="Trip Vessel Name" value={item.vessel_name || ""} onChange={e => handleItemChange(i, "vessel_name", e.target.value)} />
                                    </Col>
                                    <Col md={6}>
                                        <label className="extra-small fw-bold text-muted">Trip Description</label>
                                        <Input type="text" placeholder="Trip Description" value={item.description || ""} onChange={e => handleItemChange(i, "description", e.target.value)} />
                                    </Col>
                                </Row>

                                {item.line_total > 0 && (
                                    <div className="mt-3 p-2 bg-white rounded border d-flex gap-3 overflow-auto small shadow-sm">
                                        <div className="text-nowrap text-secondary">Normal: <b>{item.normal_hrs}h</b> / OT: <b>{item.normal_hrs_ot}h</b></div>
                                        <div className="text-nowrap text-secondary">After Offz: <b>{item.after_office_hrs}h</b> / OT: <b>{item.offz_hrs_ot}h</b></div>
                                        <div className="text-nowrap text-success fw-bold">Holiday: <b>{item.holiday}h</b> / OT: <b>{item.holiday_ot}h</b></div>
                                        {item.extra_charges > 0 && <div className="text-nowrap text-info">Extra: <b>${item.extra_charges}</b></div>}
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    ))}

                    <div className="d-flex justify-content-between align-items-center mt-5 border-top pt-4">
                        <Button color="dark" outline className="rounded-pill px-4" onClick={() => setItems([...items, { ...items[0], line_total: 0, work_start_datetime: null, work_end_datetime: null, is_holiday: false, extra_charges: 0, extra_charges_description: "", vessel_name: "", description: "" }])}>
                            <i className="bi bi-plus-lg me-1"></i> Add Trip Line
                        </Button>
                        <div className="text-end">
                            <div className="small fw-bold text-muted">Subtotal: ${subtotal.toFixed(2)}</div>
                            <div className="small fw-bold text-muted">GST ({form.gst_percent}%): ${gstAmount.toFixed(2)}</div>
                            <div className="h2 fw-bold text-success mb-3">Grand Total: ${grandTotal.toFixed(2)}</div>
                            <Button color="success" size="lg" className="px-5 rounded-pill shadow-lg" type="submit" disabled={loading}>
                                {loading ? "Creating..." : "Generate Invoice"}
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
            <style>{`.cursor-pointer { cursor: pointer; }`}</style>
            <DeleteModal
                isOpen={deleteIndex !== null}
                toggle={() => setDeleteIndex(null)}
                title="Remove Trip Line"
                message="Are you sure you want to remove this trip line from the invoice?"
                onConfirm={() => {
                    if (deleteIndex !== null) {
                        removeItem(deleteIndex);
                        setDeleteIndex(null);
                    }
                }}
            />
        </LocalizationProvider>
    );
};

export default CreateManualInvoice;